export default "__VITE_ASSET__DNDI_vPn__"